// from client to GW server
export enum GatewayActionType {
  ACKNOWLEDGE = 'ACKNOWLEDGE',
  AUTHORIZE = 'AUTHORIZE',
  PING = 'PING',
  SUBSCRIBE = 'SUBSCRIBE',
  UNSUBSCRIBE = 'UNSUBSCRIBE',
}

// GW subscription type
export enum GatewaySubType {
  ASOI_NOTES = 'ASOI_NOTES',
  FLOWS = 'FLOWS',
  FLOW_LEADS = 'FLOW_LEADS',
  LEADS = 'LEADS',
  NEWS = 'NEWS',
  SOURCE_LEADS = 'SOURCE_LEADS',
  SPECIFIC_NEWS = 'SPECIFIC_NEWS',
  USER_ASOI_NOTES = 'USER_ASOI_NOTES',
  USER_NEWS = 'USER_NEWS',
  USER_NEWSBREAKS = 'USER_NEWSBREAKS',
  USER_NOTIFICATIONS = 'USER_NOTIFICATIONS',
  USER_PROFILE = 'USER_PROFILE',
}

export enum ActionErrorCode {
  SERVER_ERROR = 'SERVER_ERROR',
  UNPROCESSABLE_ENTITY = 'UNPROCESSABLE_ENTITY',
  UNAUTHORIZED = 'UNAUTHORIZED',
  INVALID_ACCESS_TOKEN = 'INVALID_ACCESS_TOKEN',
  EXPIRED_ACCESS_TOKEN = 'EXPIRED_ACCESS_TOKEN',
  USER_BLOCKED = 'USER_BLOCKED',
  ALREADY_SUBSCRIBED = 'ALREADY_SUBSCRIBED',
  NOT_SUBSCRIBED = 'NOT_SUBSCRIBED',
  NEWS_NOT_FOUND = 'NEWS_NOT_FOUND',
  FLOW_NOT_FOUND = 'FLOW_NOT_FOUND',
  FLOW_NOT_ALLOWED = 'FLOW_NOT_ALLOWED',
  SOURCE_NOT_FOUND = 'SOURCE_NOT_FOUND',
  MESSAGE_NOT_FOUND = 'MESSAGE_NOT_FOUND',
}

export enum GatewayInMessageType {
  ACTION_SUCCESS = 'ACTION_SUCCESS',
  ACTION_ERROR = 'ACTION_ERROR',
  ACCESS_TOKEN_EXPIRED = 'ACCESS_TOKEN_EXPIRED',
  SUBSCRIPTION = 'SUBSCRIPTION',
}
